import { LocalizedLink } from 'components/LocalizedLink';
import { ACTIVE_BONUSES_URL } from 'modules/bonuses/constants';
import type { FC } from 'react';
import { Trans } from 'react-i18next';

export const BonusReceived: FC = () => (
  <p className="white-text">
    <Trans
      components={{ l: <LocalizedLink href={ACTIVE_BONUSES_URL} /> }}
      i18nKey="common:tooltips.bonusReceived.text"
    />
  </p>
);
